import { css } from 'lit';

export default css`
  /* Transitions */
  --duration-fast: 0.1s;            /* Fast transition */
  --duration-base: 0.2s;            /* Base transition */
  --duration-slow: 0.3s;            /* Slow transition */
  --easing-ease: ease;              /* Default easing */
  --transition-hover: color var(--duration-base) var(--easing-ease), transform var(--duration-base) var(--easing-ease); /* Hover transition */
`;
